import client from "@/api/client";

export async function downloadExport(path, params) {
  const res = await client.get(path, { params, responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const match = cd.match(/filename="([^"]+)"/);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : "export.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
